// extracted by mini-css-extract-plugin
export default {"subCategoriesSelector":"_lm53zk","selectorsDivider":"_1j6bi0g"};